import { render } from "./AboutView.vue?vue&type=template&id=8814808c&scoped=true"
import script from "./AboutView.vue?vue&type=script&lang=js"
export * from "./AboutView.vue?vue&type=script&lang=js"

import "./AboutView.vue?vue&type=style&index=0&id=8814808c&scoped=true&lang=css"

import exportComponent from "C:\\Development\\Portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8814808c"]])

export default __exports__